import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class OverlayService {

  private overlayId = 'app-toast-overlay';

  show() {
    if (!document.getElementById(this.overlayId)) {

      const overlay = document.createElement('div');
      overlay.className = 'global-toast-overlay';
      overlay.id = this.overlayId;

      document.body.appendChild(overlay);
      document.body.classList.add('toast-open');
    }
  }

  hide() {
    const overlay = document.getElementById(this.overlayId);

    if (overlay) {
      overlay.remove();
    }

    document.body.classList.remove('toast-open');
  }
}